export const GetPlans = ({ plans }) => plans;
export const GetNamePlan = ({ action_plan }) => action_plan?.name ?? "";
export const GetIdPlan = ({ action_plan }) => action_plan?.id;
export const GetObjectiveName = ({ action_plan }) =>
  action_plan?.objective?.name ?? "";
export const GetObjectiveId = ({ action_plan }) => action_plan?.objective?.id;
const STATUS_MAP = {
  planned: { title: "Planejado", color: "info" },
  "in-progress": { title: "Em progresso", color: "warning" },
  finished: { title: "Finalizado", color: "success" },
  cancelled: { title: "Cancelado", color: "secondary" },
  delayed: { title: "Atrasado", color: "danger" },
  stopped: { title: "Paralizado", color: "deep-orange" },
  waiting: { title: "Aguardando", color: "orange" },
};

/** Normaliza status vindo do backend (português ou inglês) para a chave canônica. */
export const GetStatusKey = () => (status = "") => {
  const s = String(status || "").toLowerCase().trim();
  if (STATUS_MAP[s]) return s;
  const ptToKey = {
    planejado: "planned",
    "em progresso": "in-progress",
    finalizado: "finished",
    cancelado: "cancelled",
    atrasado: "delayed",
    paralizado: "stopped",
    aguardando: "waiting",
  };
  return ptToKey[s] || s;
};

export const GetMappedStatus = () => STATUS_MAP;
